import styled from 'styled-components';
import ProductCard from '../card/ProductCard';

export default function AccessorySelection({ product }) {

    if (!product) {
        return <h3 style={{textAlign: 'center', margin: '2rem 0rem'}}> Seleccione una Marca y un Producto para ver sus Accesorios</h3>;
    }

    const { producto } = product;

    return (
        <StyledAccessorySelection>
            <div className="containerStyledAccessory">
                <ProductCard product={producto} type="accessory"/>
            </div>
        </StyledAccessorySelection>
    )
}

const StyledAccessorySelection = styled.div`
    .containerStyledAccessory{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 2rem 0rem;
        @media (min-width: 992px){
            padding: 0rem 0rem 0rem 3rem;
        }
    }
`
